export default {"src":"/blogs/_next/static/media/Check.cd68b1ae.svg","height":15,"width":15,"blurWidth":0,"blurHeight":0};